import providerCatalog from "./voice-provider-catalog.json";

export const VOICE_MODELS = providerCatalog.providers.flatMap((provider) =>
    provider.models.map((model) => ({
        id: model.id,
        provider: provider.id,
        label: provider.label,
        description: model.label
    }))
);

export const DEFAULT_VOICE_MODEL =
    providerCatalog.providers.find((provider) => provider.id === "xai")?.defaultModel ||
    VOICE_MODELS[0]?.id;

const STORAGE_KEY = "hrp.voice.model";
const PROVIDER_WS_BASE = {
    xai: "wss://api.x.ai/v1/realtime",
    openai: "wss://api.openai.com/v1/realtime"
};

function getProviderEntry(providerId) {
    return providerCatalog.providers.find((provider) => provider.id === providerId) || null;
}

export function loadVoiceModel() {
    try {
        const stored = window.localStorage?.getItem(STORAGE_KEY);
        if (stored && VOICE_MODELS.some((model) => model.id === stored)) return stored;
    } catch {
        // ignore
    }
    return DEFAULT_VOICE_MODEL;
}

export function saveVoiceModel(modelId) {
    if (!VOICE_MODELS.some((model) => model.id === modelId)) return;
    try {
        window.localStorage?.setItem(STORAGE_KEY, modelId);
    } catch {
        // ignore
    }
}

export function getProvider(modelId) {
    return VOICE_MODELS.find((model) => model.id === modelId)?.provider || "xai";
}

export function getDefaultVoice(providerId) {
    return getProviderEntry(providerId)?.defaultVoice || "eve";
}

export function getVoices(providerId) {
    return getProviderEntry(providerId)?.voices || [];
}

export function getModels(providerId) {
    return getProviderEntry(providerId)?.models || [];
}

export function resolveModel(modelId) {
    const found = VOICE_MODELS.find((model) => model.id === modelId);
    if (found) {
        return {
            model: found.id,
            provider: found.provider,
            voice: getDefaultVoice(found.provider)
        };
    }
    const fallback = VOICE_MODELS.find((model) => model.id === DEFAULT_VOICE_MODEL) || VOICE_MODELS[0];
    return {
        model: fallback.id,
        provider: fallback.provider,
        voice: getDefaultVoice(fallback.provider)
    };
}

export function resolveAgentConfig(agentConfig = {}) {
    if (agentConfig.provider && agentConfig.model) {
        return {
            provider: agentConfig.provider,
            model: agentConfig.model,
            voice: agentConfig.voice || getDefaultVoice(agentConfig.provider)
        };
    }
    return resolveModel(agentConfig.model || DEFAULT_VOICE_MODEL);
}

export function buildVoiceWsUrl(modelOrConfig) {
    const resolved = typeof modelOrConfig === "string"
        ? resolveModel(modelOrConfig)
        : resolveAgentConfig(modelOrConfig || {});
    const base = PROVIDER_WS_BASE[resolved.provider] || PROVIDER_WS_BASE.xai;
    return `${base}?model=${encodeURIComponent(resolved.model)}`;
}
